export default __webpack_public_path__ + "static/media/gallery_00.86dfbe01.jpg";